<script setup>

import {convertPriorityToColor, HospitalTypeLabel, StartTriageColorLabel} from "../../choices";
import {getRemainingTimeMessage} from "./td/utils";
import {computed} from "vue";
import {pgettext} from "../../../../utils/translate";
import {GenderLabel, YesNo, YesNoLabels} from "../../../../choices";
import {unitType, ventilated} from "../../utils";
import {useDisplay} from "vuetify";

const props = defineProps({
  patient: {
    type: Object,
    required: true
  },
  now: {
    type: Object,
    required: true
  }
})

const {smAndDown} = useDisplay()


const color = computed(() => {
  return convertPriorityToColor(props.patient.transportPriority).toLowerCase()
})

const estimatedTimeToArrival = computed(() => {
  return getRemainingTimeMessage(props.patient.eta, props.patient.transportMinutes, props.now)
})
</script>

<template>
  <v-alert border="start" :color="color" class="mb-1">
    <template #title>
      <div class="d-flex flex-wrap font-weight-bold mb-2">
        <div>{{ patient.tic }}</div>
        <div class="mx-3">-</div>
        <div>{{ patient.diagnose }}</div>
      </div>
    </template>
    <v-row no-gutters>
      <v-col cols="12" md="4">
        <dl>
          <dt>{{ pgettext('label', 'Gender') }}:</dt>
          <dd>{{ GenderLabel[patient.gender] }}</dd>
          <dt>{{ pgettext('label', 'Child') }}:</dt>
          <dd>
            <strong class="text-red">
              <template v-if="patient.isChild === true">{{ YesNoLabels[YesNo.YES] }}</template>
              <template v-else>{{ YesNoLabels[YesNo.YES] }}</template>
            </strong>
          </dd>
          <dt>{{ pgettext('label', 'ALV') }}:</dt>
          <dd>{{ ventilated(patient.ventilated) }}</dd>
          <template v-if="smAndDown">
            <dt>{{ pgettext('label', 'Unit Type') }}:</dt>
            <dd>{{ unitType(patient.unitType, patient.unitTypeSpec) }}</dd>
            <dt>{{ pgettext('label', 'Destination Hospital') }}:</dt>
            <dd>{{ patient.hospital?.name }}</dd>
            <dt>{{ pgettext('label', 'Hospital Type') }}:</dt>
            <dd>{{ HospitalTypeLabel[patient.hospitalType] }}</dd>
            <dt>{{ pgettext('label', 'Estimated Time To Arrival') }}:</dt>
            <dd>{{ estimatedTimeToArrival }}</dd>
            <dt>{{ pgettext('label', 'Color') }}:</dt>
            <dd>{{ StartTriageColorLabel[convertPriorityToColor(patient.transportPriority)].toUpperCase() }}</dd>
            <dt>{{ pgettext('label', 'TIC Card Number') }}:</dt>
            <dd>{{ patient.tic }}</dd>
          </template>
        </dl>
      </v-col>
      <v-col v-if="!smAndDown" cols="12" md="4">
        <dl>
          <dt>{{ pgettext('label', 'Unit Type') }}:</dt>
          <dd>{{ unitType(patient.unitType, patient.unitTypeSpec) }}</dd>
          <dt>{{ pgettext('label', 'Destination Hospital') }}:</dt>
          <dd>{{ patient.hospital?.name }}</dd>
          <dt>{{ pgettext('label', 'Hospital Type') }}:</dt>
          <dd>{{ HospitalTypeLabel[patient.hospitalType] }}</dd>
        </dl>
      </v-col>
      <v-col cols="12" md="4">
        <dl>
          <dt>{{ pgettext('label', 'Estimated Time To Arrival') }}:</dt>
          <dd>{{ estimatedTimeToArrival }}</dd>
          <dt>{{ pgettext('label', 'Color') }}:</dt>
          <dd>{{ StartTriageColorLabel[convertPriorityToColor(patient.transportPriority)].toUpperCase() }}</dd>
          <dt>{{ pgettext('label', 'TIC Card Number') }}:</dt>
          <dd>{{ patient.tic }}</dd>
        </dl>
      </v-col>
    </v-row>
  </v-alert>
</template>